import useTranslate from 'modules/local/useTranslate'
import React, {useCallback, useContext} from 'react'
import {NullAsDefault} from 'views/Shared'
import {SelectWidget} from "../../../../AppLocals/custom/ReactSelectComponents";
import WorkspaceContext from "../../../WorkspaceContext";
import _ from "lodash"

export const TeacherFilter = ({
    owner_id,
    owner_type,
    defaultValue,
    hashtagsFilter,
    value: filter = {
    hashtags: undefined
    },
    onChange: setValues = NullAsDefault,
}) => {
  const t = useTranslate();
  const {organization} = useContext(WorkspaceContext);

  const handleChange = useCallback(
    (name, value) => {
      setValues({
        ...filter,
        [name]: value,
      })
    },
    [filter]
  )

  return (
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          <div className="flex items-center gap-2">
              <span className="text-sm text-color-400 italic whitespace-no-wrap">
                  {`${t('supervisory position')} : `}
              </span>
              <SelectWidget
                  className="w-full"
                  name={"hashtags"}
                  value={filter.hashtags || undefined}
                  allowClear={true}
                  disabled={!!hashtagsFilter}
                  placeholder={t('click to select')}
                  onChange={(value) => {handleChange("hashtags", value)}}
                  options={_.get(organization, 'workspace_settings.courses.groups.teacher_groups', []).map(e => {
                      return {
                          key: 'hashtags.' + e,
                          value: e,
                          label: e,
                      }
                  })}
              />
          </div>
      </div>
  )
}

export default TeacherFilter
